
import React, { useEffect, useState } from "react";

import "./../../pagescss/SubjectTopics.css";

import PdfFiles from "../AllData/PdfFiles";
import StudyOption from "../AllData/HomeData";

import TopNavbar from "../home/TopNavbar";
import TopHeader from "../home/TopHeader";

function AllSubjectTopics() {
    const subject = "physics";
    const type = "ncertbook";

    const [pdfs, setPdfs] = useState([]);

    const studyOptions = StudyOption;

    const matchingItem = studyOptions?.find(
        (item) => item.id === type
    );

    const iconName = matchingItem
        ? matchingItem.symbol
        : "📝";

    useEffect(() => {
        const filteredPdfs = PdfFiles.filter(
            (pdf) =>
                pdf.subject === subject &&
                pdf.type === type
        );

        setPdfs(filteredPdfs);
    }, []);

    return (
        <div className="subject-topics-page">

            <TopNavbar
                name={
                    subject.charAt(0).toUpperCase() +
                    subject.slice(1)
                }
            />

            <TopHeader
                name={
                    subject.charAt(0).toUpperCase() +
                    subject.slice(1)
                }
            />

            <div className="subject-categories">

            <p>{type}</p>

                {pdfs.map((pdf) => (

                    <div
                        className="topic-card"
                        key={pdf.id}
                    >
                        <p>
                             {pdf.name}
                        </p>
                    </div>

                ))}

            </div>

        </div>
    );
}

export default AllSubjectTopics;
